export default class Subscriptions {
  constructor (data) {
    if (!data) throw new Error('Wrong Subscriptions data')

    this.bought = data.bought ?? false
    this.expires = data.expires ?? null
    this.nomenklatura = data.nomenklatura ?? ''
    this.type = data.type ?? ''
  }
}
